import instance from '.'
import { err, getResult } from '../utils/functions'
import { APIResult } from '../utils/types'
import { MatchmakingStats } from './types/matchmaking'

export function getMatchmakingLeaderboard(params?: {
  limit?: number
  offset?: number
}): Promise<APIResult<MatchmakingStats[]>> {
  return instance
    .get('/api/matchmaking/leaderboard', { params })
    .catch((e) => err(e))
    .then((res) => getResult<MatchmakingStats[]>(res))
}

export function getMyMatchmakingStats(): Promise<APIResult<MatchmakingStats>> {
  return instance
    .get('/api/matchmaking/me')
    .catch((e) => err(e))
    .then((res) => getResult<MatchmakingStats>(res))
}
